var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2924 0H3.70762C2.21241 0 1 1.26442 1 2.82379V12.3429C1 13.9026 2.21241 15.1667 3.70762 15.1667H12.2924C13.7876 15.1667 15 13.9026 15 12.3429V2.82379C15 1.26442 13.7878 0 12.2924 0V0ZM7.90934 12.4261C5.34524 12.4261 3.26602 10.2581 3.26602 7.58359C3.26618 4.90901 5.34504 2.74105 7.90934 2.74105C10.4738 2.74105 12.5527 4.9091 12.5527 7.58359C12.5527 10.2581 10.4736 12.4261 7.90934 12.4261Z",
    fill: "url(#paint0_linear_2553_78)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47203 4.29525H7.34383V6.91074H4.83594V8.08734H7.34383V10.703H8.47203V8.08734H10.9802V6.91074H8.47203V4.29525Z",
    fill: "url(#paint1_linear_2553_78)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2553_78",
    x1: 1,
    y1: 7.58333,
    x2: 15,
    y2: 7.58333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2553_78",
    x1: 4.83594,
    y1: 7.49912,
    x2: 10.9802,
    y2: 7.49912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9F20"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErt);
export default __webpack_public_path__ + "static/media/ert.4a9c08400d0460f89a80151eeaf035b8.svg";
export { ForwardRef as ReactComponent };